import React from "react";
import "../../style/loading.css";

export default function Loading() {
  return (
    <section className="h-screen w-full overflow-hidden flex items-center justify-center bg-base-100">
      <div className="loader">
        <p>lädt</p>
        <div className="words">
          <span className="word">website</span>
          <span className="word">software</span>
          <span className="word">ideen</span>
          <span className="word">pläne</span>
          <span className="word">zukunft</span>
        </div>
      </div>
    </section>
  );
}
